module.exports = __webpack_public_path__ + "static/media/ic_cell_danger.477723e1.svg";